import React from 'react';
import { Outlet } from 'react-router-dom';
import './global.css';

// eslint-disable-next-line import/order
import { ThemeProvider } from './theme/theme-provider';
import { useScrollToTop } from './hooks/use-scroll-to-top';

// Preload MUI experimental APIs to prevent timing issues in development

import { LocalizationProvider } from './locales';
import { Snackbar } from './components/snackbar';
import { AuthProvider } from './auth/context/jwt';
import { I18nProvider } from './locales/i18n-provider';
import { ProgressBar } from './components/progress-bar';
import { MotionLazy } from './components/animate/motion-lazy';
import { GoogleAnalytics } from './components/google-analytics';
import { VirtualLoginProvider } from './contexts/virtual-login-context';
import { ActiveCompetitionProvider } from './contexts/active-competition-context';
import { SettingsDrawer, defaultSettings, SettingsProvider } from './components/settings';

// Root layout route for the data router. Hosts every global provider and
// renders the matched child route via <Outlet />.
export default function App() {
  useScrollToTop();

  return (
    <I18nProvider>
      <LocalizationProvider>
        <AuthProvider>
          <VirtualLoginProvider>
            <ActiveCompetitionProvider>
              <SettingsProvider settings={defaultSettings}>
                <ThemeProvider>
                  <MotionLazy>
                    <GoogleAnalytics />
                    <Snackbar />
                    <ProgressBar />
                    <SettingsDrawer />
                    <Outlet />
                  </MotionLazy>
                </ThemeProvider>
              </SettingsProvider>
            </ActiveCompetitionProvider>
          </VirtualLoginProvider>
        </AuthProvider>
      </LocalizationProvider>
    </I18nProvider>
  );
}
